export default [{
    path: '/monitoring/queues',
    name: 'monitoring-queues',
    component: () => import('@/views/apps/monitoring/queues/index.vue'),
  }]